
import BaseMixin from '@/views/mixin.vue'
import compSearch from './search'
import { mapState } from 'vuex'
import {
    HttpB2cList,
} from '@/service/boss/b2corder'
import { DropdownMenu, Dropdown, DropdownItem, Icon, Button } from 'view-design'

import compImport from '../compimport'
import compAdd from './compadd'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        compImport,
        compAdd,

    },
    data () {
        return {
            isSuper: this.$store.state.userinfo.isSuper,
            fudingdan: 0,
        };
    },
    methods: {
        httpList: HttpB2cList,
        handleOperate (data, type) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeids: data,
                        querytype: 'query'
                    }
                    break;
                case 'queryBlank':
                    const url = this.$router.resolve({
                        name: 'b2cOrderupdate',
                        params: { type: 'query' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit': {
                    const url = this.$router.resolve({
                        name: 'b2cOrderupdate',
                        params: { type: 'edit' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'disabled': {
                    this.showDel = true;
                    this.operate = {
                        title: '停用',
                        desc: `确定停用操作？`,
                        type,
                        id: data,
                    }
                    break;
                }
                case 'actived': {
                    this.showDel = true;
                    this.operate = {
                        title: '激活',
                        desc: `确定激活操作？`,
                        type,
                        id: data,
                    }
                    break;
                }
                case 'importBase':
                    this.operate = {
                        show: true,
                        title: '导入基本信息',
                        width: 460,
                        showFooter: false,
                        erpskutitle: "直接更新：品类、项目以外的其他数据直接更新",
                        warningtitle: 'ERPSKU必须区分大小写',
                        component: "compImport",
                        comtype: 1,
                    }
                    break
                case 'importWarehouse':
                    this.operate = {
                        show: true,
                        title: '导入仓库发货信息',
                        width: 460,
                        showFooter: false,
                        erpskutitle: "直接更新：仓库发货信息直接更新",
                        warningtitle: 'ERPSKU必须区分大小写',
                        component: "compImport",
                        comtype: 2,
                    }
                    break
                case 'importHead':
                    this.operate = {
                        show: true,
                        title: '导入头程信息',
                        width: 460,
                        showFooter: false,
                        erpskutitle: "直接更新：头程信息直接更新",
                        warningtitle: 'ERPSKU必须区分大小写',
                        component: "compImport",
                        comtype: 3,
                    }
                    break
                case 'importBuy':
                    this.operate = {
                        show: true,
                        title: '导入采购信息',
                        width: 460,
                        showFooter: false,
                        erpskutitle: "直接更新：采购信息直接更新",
                        warningtitle: 'ERPSKU必须区分大小写',
                        component: "compImport",
                        comtype: 4,
                    }
                    break

            }
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'cancel': request = HttpCancelOrder; params = { orderId: this.operate.id }; break;
                case 'resetorder': request = HttpResetOrder; params = { orderIds: this.checkedId.join(',') }; break;
                case 'backnormal': request = HttpRecoveryNormal; params = { orderIds: this.checkedId.join(','), recoveryNormal: 1 }; break;
                case 'project': ; break;
                case 'passapprove': request = HttptoExamine; params = { orderIds: this.checkedId.join(',') }; break;

            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
                // console.log(this.checkedId)
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
        pushsubmit (type) {
            let request, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'sendyuncang': request = HttpPushFbb; params = { orderIds: this.checkedId.join(','), node: 0 }; break;
                // case 'forcedpush': request = HttpPushFbb; params = { orderIds: this.checkedId.join(','), node:1 }; break;

                case 'loadcost': request = HttpComuteCosts; params = { orderIds: this.checkedId.join(','), node: 0 }; break;
                case 'resetcost': request = HttpComuteCosts; params = { orderIds: this.checkedId.join(','), node: 1 }; break;

            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            });
        }
    },
    computed: {
        ...mapState('boss', ['products', 'warehouseList']),
        columns () {
            let datalist = [{
                type: 'selection',
                width: 60,
            }, {
                title: "操作",
                width: 90,
                render: (h, { row }) => {
                    const id = row.id, status = row.orderStatus;
                    return <Dropdown placement="bottom-start" trigger="click">
                        <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                        <DropdownMenu slot="list" class="text-left">
                            <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'query', row.parentId)}>查看</DropdownItem>

                            <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'edit', row.parentId)}>编辑</DropdownItem>

                            <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'disabled', row.parentId)}>停用</DropdownItem>

                        </DropdownMenu>
                    </Dropdown >
                }
            },
            {
                title: '品类',
                width: 80,
                render: (h, { row }) => {
                    return <div></div>
                },

            },
            {
                title: '项目/ERPSKU/工厂产品编码',
                // width:100,
                render: (h, { row }) => {
                    const id = row.lineId;
                    const product = this.products.filter((item) => {
                        return id == item.id
                    })[0] || {};
                    return <div>
                        <div>{row.channelFlag}[{row.channel}]</div>
                        <div><span class="font-bold">{product.name || '-'}</span></div>
                        <div>
                            <a onClick={this.handleOperate.bind(this, row.id, 'query', row.parentId)}>{row.id}</a>
                            <a onClick={this.handleOperate.bind(this, row.id, 'queryBlank', row.parentId)}><Icon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                        <div>{row.orderNo}</div>
                    </div>

                },
            },
            {
                title: '标签',
                width: 80,
                render: (h, { row }) => {
                    switch (row.orderStatus) {
                        case 'pending': return <Button class="b2cspan-error span-padding">未支付</Button>; break;
                        case 'unshipped': return <Button class="b2cspan-middle-content span-padding">未发货</Button>; break;
                        case 'approved': return <Button class="b2cspan-success span-padding">已审核</Button>; break;
                        case 'assigned': return <Button class="b2cspan-primary span-padding">已分配</Button>; break;
                        case 'picked': return <Button class="b2cspan-info span-padding">已配货</Button>; break;
                        case 'shipped': return <Button class="b2cspan-light-content span-padding">已发货</Button>; break;
                        case 'canceled': return <Button class="b2cspan-warning span-padding">已取消</Button>; break;
                        case 'refunded': return <Button class="b2cspan-dark-primary span-padding">已退款</Button>; break;
                    }

                },

            },
            {
                title: '补货状态/是否停用',
                // width:100,
                render: (h, { row }) => {

                    let sellers = row.saleOrderItemsList.map(item => {
                        return <div>{item.sellerSku} * {item.quantity}</div>
                    })

                    return <div>
                        <div >{sellers}</div>
                        <div class="font-bold">{row.amount} {row.currencyCode}</div>
                        <div class="b2ccolor-warning font-weight" v-show={row.fulfillmentChannel == 'MFN'}>{row.fulfillmentChannel}</div>
                        <div class="b2ccolor-success font-weight" v-show={row.fulfillmentChannel == 'AFN'}>{row.fulfillmentChannel}</div>
                    </div>
                },

            },
            {
                title: 'FOB(USD)/总库存',
                // width:200,
                render: (h, { row }) => {
                    if (row.orgWarehouseId != 0) {
                        const id = row.orgWarehouseId,
                            result = this.warehouseList.filter((item) => {
                                return item.id == id;
                            })[0] || {};

                        return <div>
                            <div>{result.title}[{result.code}]</div>
                            <div>{row.saleOrderDetails.carrier || '-'}</div>
                            <div>{row.shippingMethodCode || '-'}</div>
                        </div>
                    } else {
                        return <div>
                            <div>未分配到仓库</div>
                            <div>{row.saleOrderDetails.carrier || '-'}</div>
                            <div>{row.shippingMethodCode || '-'}</div>
                        </div>
                    }

                },

            },
            {
                title: '品名中文/品名英文',
                width: 140,
                render: (h, { row }) => {
                    var ordertype;
                    switch (row.orderType) {
                        case 'normally': ordertype = <div class="b2ccolor-dark-primary font-weight span-padding">正常销售</div>; break;
                        case 'celebrity': ordertype = <div class="b2ccolor-error font-weight span-padding">展示订单</div>; break;
                        case 'distribution': ordertype = <div class="b2ccolor-success font-weight span-padding">分销订单</div>; break;
                        case 'brush': ordertype = <div class="b2ccolor-warning font-weight span-padding">刷评订单</div>; break;
                    }
                    const urls = {
                        isCelebrity: '/picture/hongren.png',
                        isSample: '/picture/yangpin.png',
                        isReshipment: '/picture/bufa.png',
                        isDismantlementfu: '/picture/chaifu.png',
                        isDismantlementzi: '/picture/chaizi.png',
                        isAddition: '/picture/lipin.png',
                    }
                    const titles = {
                        isCelebrity: '红人订单',
                        isSample: '样品订单',
                        isReshipment: '补发订单',
                        isDismantlementfu: '拆解父订单',
                        isDismantlementzi: '拆解子订单',
                        isAddition: '礼品订单',
                    }
                    var imgs = ['isCelebrity', 'isSample', 'isReshipment', 'isDismantlement', 'isAddition'].map((val) => {
                        if (val == 'isDismantlement' && row['isDismantlement'] == 'Y' && row.parentId == 0) {

                            return h('span', [
                                h('Tooltip', {
                                    props: {
                                        placement: 'top',
                                        transfer: true,
                                        content: titles['isDismantlementfu']
                                    }
                                }, [
                                    h('img', {
                                        attrs: {
                                            src: urls['isDismantlementfu'],
                                            style: "width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ])


                        } else if (val == 'isDismantlement' && row['isDismantlement'] == 'Y' && row.parentId != 0) {

                            return h('span', [
                                h('Tooltip', {
                                    props: {
                                        placement: 'top',
                                        transfer: true,
                                        content: titles['isDismantlementzi']
                                    }
                                }, [
                                    h('img', {
                                        attrs: {
                                            src: urls['isDismantlementzi'],
                                            style: "width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ])
                        } else {

                            return row[val] == 'Y' ? h('span', [
                                h('Tooltip', {
                                    props: {
                                        placement: 'top',
                                        transfer: true,
                                        content: titles[val]
                                    }
                                }, [
                                    h('img', {
                                        attrs: {
                                            src: urls[val],
                                            style: "width:20px;height:20px;cursor: pointer;"
                                        },
                                    })
                                ])
                            ]) : ''

                            // return row[val]== 'Y' ? <img style="width:20px;height:20px;cursor: pointer;" src={urls[val]} title={titles[val]} alt={titles[val]}/> : ''
                        }
                    })
                    var orderFont;

                    if (row.isPrime == 'Y') {
                        orderFont = <span class="b2cfont-italic b2ccolor-info">Prime</span>
                    } else if (row.isOnsite == 'Y') {
                        orderFont = <span class="b2cfont-italic b2ccolor-content">Onsite</span>
                    } else if (row.isBusinessOrder == 'Y') {
                        orderFont = <span class="b2cfont-italic b2ccolor-error">Business</span>
                    } else if (row.shipmentType == 1) {
                        orderFont = <span class="b2cfont-italic b2ccolor-warning">Store</span>
                    }

                    var errorcode;
                    switch (row.errorCode) {
                        // case 'unexception': errorcode = '无异常的订单'; break;
                        case 'systemException': errorcode = '系统异常'; break;
                        case 'produceException': errorcode = '商品无法关联'; break;
                        case 'addressException': errorcode = '订单地址异常'; break;
                        case 'updateException': errorcode = '订单更新异常'; break;
                        case 'pickingException': errorcode = '订单配货异常'; break;
                        case 'cancelException': errorcode = '订单取消异常'; break;
                        case 'trackingException': errorcode = 'Tracking异常'; break;
                        case 'costException': errorcode = '订单成本异常'; break;
                        case 'carrierException': errorcode = '订单发运方式异常'; break;
                        case 'uploadException': errorcode = '订单附件上传异常'; break;
                    }

                    return <div>
                        <div>{ordertype}{imgs}</div>
                        <div>{orderFont}</div>
                        <div v-show={errorcode}><span class="error-span margin-right-10">{errorcode}</span></div>
                    </div>
                }
            },
            {
                title: '重量(g)/体积(cm3)',
                // width:100,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.channelCreated || '-'}</div>
                        <div>{row.latestShipDate || '-'}</div>
                    </div>

                },
            },
            {
                title: '重量(g)/体积(cm3)',
                // maxWidth:100,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.channelCreated || '-'}</div>
                        <div>{row.latestShipDate || '-'}</div>
                    </div>

                },
            },
            {
                title: '更新时间',
                width: 90,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.channelCreated || '-'}</div>
                    </div>

                },
            },

            ];
            return datalist;
        },
    },
};




